/**
 * On Course Short Game Reducers
 */
import {
    OCTSHORTGAME_ACTION,
    ALL_OCTSHORTGAME,
    DELETE_OCTSHORTGAME,
    ADD_OCTSHORTGAME,
    FETCH_OCTSHORTGAME,
    EDIT_OCTSHORTGAME,
    ALL_OCTSHORTGAMESHOT,
    FETCH_OCTSHORTGAMECHART,
    FETCH_SHORTSHOTCHART
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    octshortgamelist:[],
    octshortgameshot:[],
    particularoctshortgame:[],
    shortgamechart:[],
    shortgameshotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCTSHORTGAME_ACTION:
            return { ...state, loading: true };       

        case ALL_OCTSHORTGAME:
            return { ...state, loading: false, octshortgamelist: action.payload };     
         
        case ALL_OCTSHORTGAMESHOT:
            return { ...state, loading: false, octshortgameshot: action.payload };     
            
        case ADD_OCTSHORTGAME:
            return { ...state, loading: false };     
         
        case FETCH_OCTSHORTGAME:
            return { ...state, loading: false, particularoctshortgame: action.payload };  
            
        case EDIT_OCTSHORTGAME:
            return { ...state, loading: false }; 
            
        case DELETE_OCTSHORTGAME:
            return { ...state, loading: false };     

        case FETCH_OCTSHORTGAMECHART:
            return { ...state, loading: false, shortgamechart: action.payload }; 
            
        case FETCH_SHORTSHOTCHART:
            return { ...state, loading: false, shortgameshotchart: action.payload }; 
        
        default: return { ...state };

     }
 }